import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';

import { Proficiency } from '../../models/proficiency';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ProficiencyService {
  /**
   * A service providing access to proficiencies via the API.
   */

  constructor(
    private apiService: ApiService
  ) {}

  /**
   * Get a page of proficiencies from the API.
   *
   * @param pageNumber - The requested page number.
   * @param pageSize - The requested number of proficiencies per page.
   * @return The list of proficiencies.
   */
  getProficiencies(pageNumber?: number,
                   pageSize?: number): Promise<ListResponse<Proficiency>> {
    return this.apiService.getCollectionNoFilters<Proficiency>(
      'proficiencies/',
      pageNumber,
      pageSize
    );
  }

  /**
   * Post a new proficiency to the API.
   *
   * @param proficiency - The new Proficiency object to create.
   * @return The new proficiency returned from the API.
   */
  addProficiency(proficiency: Proficiency): Promise<Proficiency> {
    return this.apiService.postToAPI<Proficiency>(
      'proficiencies/',
      {
        name: proficiency.name,
        icon_color_hex: proficiency.icon_color_hex,
        icon_initials: proficiency.icon_initials,
        create_alert_on_expiration: proficiency.create_alert_on_expiration,
        expiration_alert_prevents_check_in: proficiency.expiration_alert_prevents_check_in,
        expiration_alert_color_hex: proficiency.expiration_alert_color_hex,
        expiration_alert_has_alert_icon: proficiency.expiration_alert_has_alert_icon,
        no_check_in_expiration_months: proficiency.no_check_in_expiration_months,
        expiration_after_granted_by_document_days: proficiency.expiration_after_granted_by_document_days,
      }
    );
  }

  /**
   * Update a proficiency by making a PUT request to the API.
   *
   * @param proficiency - The proficiency, with updated values.
   * @return The updated proficiency returned from the API.
   */
  updateProficiency(proficiency: Proficiency): Promise<Proficiency> {
    return this.apiService.putToAPI<Proficiency>(
      proficiency.url,
      proficiency
    );
  }
}
